var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"train"}},[_vm._m(0),_c('TrainList',{attrs:{"dataArray":_vm.trainList}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('img',{attrs:{"src":require("../../assets/img/banner.png"),"draggable":"false"}})])
}]

export { render, staticRenderFns }